import { render } from "./next-arrow.svg.vue?vue&type=template&id=07716f31"
import script from "./next-arrow.svg.vue?vue&type=script&lang=js"
export * from "./next-arrow.svg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__